import React from 'react'

export function TrendingUpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.75 7.5a.75.75 0 01.75-.75h6a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0V8.25H14.5a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M21.018 6.958c.3.286.31.76.024 1.06l-7.408 7.75a.75.75 0 01-.932.123l-4.369-2.663-4.755 5.75a.75.75 0 11-1.156-.956l5.17-6.25a.75.75 0 01.968-.162l4.407 2.686 6.99-7.314a.75.75 0 011.061-.024z"
        clipRule="evenodd"
      />
    </svg>
  )
}
